// extracted by css-extract-rspack-plugin
export default {"badge":"badge___o__FuD6i","badge--outline":"badge--outline___OVxhZt3_","badge--shadow":"badge--shadow___ym_dgsm9"};